import * as React from 'react';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import styled from '@emotion/styled';
import ChromeReaderModeIcon from '@mui/icons-material/ChromeReaderMode';
import { useLocation, useNavigate } from 'react-router-dom';
import QuizIcon from '@mui/icons-material/Quiz';
import FileCopyIcon from '@mui/icons-material/FileCopy';

const Text = styled(ListItemText)({
    textAlign: "right"
})
const ItemButton = styled(ListItemButton)({
    borderRadius: "10px",
    "& .MuiTypography-root": {
        fontFamily: "'Yekan !important'"
    },
    "& .MuiListItemIcon-root": {
        minWidth: "unset",
        marginLeft: ".5rem"
    }
})
const adminFacilities = [
    { name: "فایل ها", icon: <FileCopyIcon />, address: "files" },
    { name: "اسنک ها", icon: <ChromeReaderModeIcon />, address: "snacks" },
    { name: "آزمون ها", icon: <QuizIcon />, address: "quizes" },
]
function CoursesMenuItems() {
    const [expand, setExpand] = React.useState(true);
    const navigate = useNavigate();
    const { state: { courseId, title } } = useLocation() as { state: { courseId: string, title: string } };
    return (
        <List
            sx={{ width: "100%", maxHeight: "80vh", overflow: "auto" }}
            component="nav"
            aria-labelledby="nested-list-subheader"
        >
            <ItemButton onClick={() => setExpand(!expand)} sx={{ bgcolor: "primary.main" }}>
                <Text primary="دوره ها" />
                {expand ? <RemoveIcon /> : <AddIcon />}
            </ItemButton>
            <Collapse in={expand} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {adminFacilities.map((item, index) => {
                        return (
                            <ItemButton
                                onClick={() => navigate(`/courses/${courseId}/${item.address}`, { state: { courseId, title } })}
                                key={index}
                                sx={{ pl: 4 }}>
                                <ListItemIcon sx={{ color: 'divider' }}>
                                    {item.icon}
                                </ListItemIcon>
                                <Text primary={item.name} />
                            </ItemButton>
                        )
                    })}
                </List>
            </Collapse>
        </List>
    );
}
export default CoursesMenuItems;